import { COLORS, TEXT_COLORS } from '../constants';
import { ColorsType } from '../types';

interface ColorsMapType {
    [key: string]: ColorsType;
}
interface NumberMapType {
    [key: string]: number;
}

/**
 * A list of monochromatic buttons.
 */
export const MONOCHROME_BUTTONS: ColorsType[] = [
    'grey',
    'light-grey',
    'black'
];

/**
 * A mapping of non-standard supported colors to their standard counterparts.
 */
export const COLOR_MAP: ColorsMapType = {
    [COLORS.BLACK]: 'grey',
    [COLORS.LIGHT_GREY]: 'grey',
    [TEXT_COLORS.DARK_GREY]: 'grey'
};

/**
 * A mapping of non-standard color weights for ghost buttons.
 */
export const GHOST_COLOR_WEIGHT_MAP: NumberMapType = {
    [COLORS.LIGHT_GREY]: 800,
    [COLORS.GREY]: 1000,
    [COLORS.BLACK]: 1200
};

/**
 * A mapping of non-standard icon color weights.
 */
export const ICON_COLOR_WEIGHT_MAP: NumberMapType = {
    [COLORS.BLACK]: 1200
};

/**
 * A mapping of non-standard background colors.
 */
export const BACKGROUND_COLOR_MAP: ColorsMapType = {
    [COLORS.LIGHT_GREY]: 'grey',
    [COLORS.GREY]: 'grey',
    [COLORS.BLACK]: 'grey'
};

/**
 * A mapping of non-standard background color weights.
 */
export const BACKGROUND_COLOR_WEIGHT_MAP: NumberMapType = {
    [COLORS.LIGHT_GREY]: 300,
    [COLORS.GREY]: 800
};
